import type { Theme } from "@mui/material/styles";
import { settingPageGrey } from "@octopus-settings/constants/ui/colors";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme: Theme) => ({
  tabs: {
    backgroundColor: settingPageGrey[50],
    padding: theme.spacing(2, 6, 0),
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.dark,
      height: 2,
      transition: theme.transitions.create("left", {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
      }),
    },
    "& .MuiTab-root": {
      transition: theme.transitions.create(["color"], {
        duration: theme.transitions.duration.shorter,
      }),
    },
    "& .MuiTab-root svg": {
      height: 16,
      transition: theme.transitions.create(["fill"], {
        duration: theme.transitions.duration.shorter,
      }),
      width: 16,
    },
    "& .MuiTab-root .MuiTypography-root": {
      fontSize: 14,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: "16px",
    },
  },
}));

export default useStyles;
